import { css } from 'styled-components';

export default css`
  .spc-card-skeleton {
    padding: 24px 15px 24px 13px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 32px;
    }
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    border-radius: 10px;
    box-shadow: 0 8px 20px 0 rgb(0 0 0 / 12%), 0 2px 3px 0 rgb(0 0 0 / 20%);
    background-color: ${(props) => props.theme.colors.WHITE};
    overflow-y: auto;
  }

  .shipping-header {
    width: 60%;
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 71%;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 50%;
    }
  }

  .shipping-loader {
    margin-top: 24px;
  }

  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;
